/*
*
* Written by : Jaime Cavazos
* Description : This file creates a cookie to store campaign information so if the user goes to another page the 
* querystring data will be captured in the cookie and parsed out 
*
*/


// Cookie Name
var ct 		= null; 			// MailChimp Campaign Name
var mc_cid 	= null; 			// MailChimmp 
var mc_eid 	= null;				// MailChimmp 

// Google 
var utm_campaign 		= null;
var utm_medium			= null;
var utm_source			= null;
var query 				= window.location.search.substring(0);



function setCookie(name_value,days) {
  
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days*24*60*60*1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name_value  + expires + "; path=/";
}




function createCookiesFromQuerystring() {
    var query = window.location.search.substring(1);
    var vars = query.split('&');
    for (var i = 0; i < vars.length; i++) {
      
     		setCookie(vars[i], 1);
      
    }
    //console.log('Query variable %s not found', variable);
}



function getCookie(cname) {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(';');
  for(var i = 0; i <ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
         
      //console.log("Value : " + c.substring(name.length, c.length));
      
      return c.substring(name.length, c.length);
    }
  }
  return "";
}




createCookiesFromQuerystring();
//console.log("VALUE : " + getCookie("ct"));


window.addEventListener("load", function(){
	updateURL();
});


//
// This appends the querystring to all the a href elements on the site
//


$(document).ready(function(){

  // left hand side navigation
  $('.slide-nav').find("a").each(function(i, obj) {
  	//console.log("NAVIGATION : " + i + " : " + obj + query);
    $(this).attr("href", obj + query);
    
	});
  
  // top main navigation
  $('.tr-main-nav').find("a").each(function(i, obj) {
  	//console.log("NAVIGATION : " + i + " : " + obj + query);
    $(this).attr("href", obj + query);
    
	});  
  
  // contact and login 
  $('.utility').find("a").each(function(i, obj) {
  	//console.log("NAVIGATION : " + i + " : " + obj + query);
    $(this).attr("href", obj + query);
    
	}); 
  
  
  
  $('.wrap').find("a").each(function(i, obj) {
  	//console.log("NAVIGATION : " + i + " : " + obj + query);
    $(this).attr("href", obj + query);
    
	}); 
  
});


function updateURL() {
    
  if (history.pushState) {
    var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + query;
    window.history.pushState({path:newurl},'',newurl);
  }

}


